import { formatDate } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { fechaParaMostrar } from './fechas-utils';

/**
 * Preserve the server's written calendar/time components. Explicit English month
 * names and UTC formatting of a synthetic carrier prevent browser locale/zone drift.
 */
@Pipe({ name: 'serverDate', standalone: true })
export class ServerDatePipe implements PipeTransform {
  constructor(@Inject(LOCALE_ID) _locale = 'en-US') {}
  transform(value: string | number | Date | null | undefined, pattern = 'dd-MMM-yyyy',
    _timezone?: string, _locale?: string): string | null {
    if (value === null || value === undefined || value === '') return null;
    const carrier = fechaParaMostrar(value);
    if (!carrier) return null;
    const formats: Record<string, string> = {
      short: 'dd-MMM-yyyy HH:mm', medium: 'dd-MMM-yyyy HH:mm:ss',
      long: 'dd-MMM-yyyy HH:mm:ss', full: 'dd-MMM-yyyy HH:mm:ss',
      shortDate: 'dd-MMM-yyyy', mediumDate: 'dd-MMM-yyyy', longDate: 'dd-MMM-yyyy',
      fullDate: 'EEEE, dd-MMM-yyyy', shortTime: 'HH:mm', mediumTime: 'HH:mm:ss',
      longTime: 'HH:mm:ss', fullTime: 'HH:mm:ss'
    };
    return formatDate(carrier, formats[pattern] ?? pattern, 'en-US', 'UTC');
  }
}
